import { filter_constants } from 'utils/constants'

// Updates window URL parameter from search and filters, to persist the current search and filters
const pushToQueryParams = (filters, search) => {
    const current_query = ['?filter=']
    if (Array.isArray(filters)) {
        if (filters.length) {
            filters.forEach((query, idx) => {
                if (idx === 0) {
                    current_query.push(query)
                } else {
                    current_query.push(`,${query}`)
                }
            })
        } else {
            // Make sure that only have 1 array (prevent multiple query bug)
            current_query.splice(1, current_query.length)
        }
    }
    current_query.push(`&search=${search}`)

    window.history.pushState(null, null, current_query.join(''))
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// Source: https://davidwalsh.name/javascript-debounce-function
const debounce = (func, wait, immediate) => {
    let timeout
    return function () {
        const context = this
        const args = arguments

        const later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        const callNow = immediate && !timeout

        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

export const debouncedUpdateQueryParams = debounce(
    (filter, search) => pushToQueryParams(filter, search),
    400,
)

export const initializeFilters = () => {
    const url_params = new URLSearchParams(window.location.search)
    const url_filters = url_params.get('filter')

    if (url_filters) {
        // parsing filter into array
        // and make sure that all items are valid (prevent wrong item bug)
        const filter_arr = url_filters
            .split(',')
            .filter(
                (item) =>
                    filter_constants.category?.includes(item) ||
                    filter_constants.language?.includes(item) ||
                    filter_constants.resolution?.includes(item),
            )
        return filter_arr
    }

    return []
}

export const initializeSearch = () => {
    var url_params = new URLSearchParams(window.location.search)
    const url_search = url_params.get('search')

    if (url_search) {
        return url_search
    }
    return ''
}
